export default __webpack_public_path__ + "static/hvac-financing-minnesota-0fa2f8bda370bf42ef8c458f8463dadd.jpg";